import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { Section, LatexFormula, renderRich } from "./shared";

function CopyBtn({ text }) {
  const [copied, setCopied] = useState(false);
  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    } catch {
      /* clipboard unavailable */
    }
  };
  return (
    <button
      onClick={onCopy}
      className="p-1 border border-black/15 hover:bg-black hover:text-white transition-colors"
      title={copied ? "Copied" : "Copy"}
      data-testid="copy-formula-btn"
    >
      {copied ? <Check className="w-3 h-3" /> : <Copy className="w-3 h-3" />}
    </button>
  );
}

function FormulaCard({ f, regex }) {
  return (
    <div className="pdf-avoid border-2 border-black bg-white shadow-[3px_3px_0_0_#000] p-3">
      <div className="flex items-start justify-between gap-2">
        <div className="flex-1 bg-[#BFDBFE] border-2 border-black px-3 py-2 leading-tight break-words text-lg overflow-x-auto">
          <LatexFormula code={f.formula} />
        </div>
        <CopyBtn text={f.formula || ""} />
      </div>
      {f.meaning && (
        <div className="mt-2 flex gap-2 items-start text-xs">
          <span className="font-mono text-[9px] uppercase tracking-widest text-[#3B82F6] mt-0.5 w-14 flex-shrink-0">Meaning</span>
          <span className="flex-1 text-zinc-800">{renderRich(f.meaning, regex)}</span>
        </div>
      )}
      {f.units && (
        <div className="mt-1 flex gap-2 items-start text-xs">
          <span className="font-mono text-[9px] uppercase tracking-widest text-[#3B82F6] mt-0.5 w-14 flex-shrink-0">Units</span>
          <span className="flex-1 text-zinc-800"><LatexFormula code={f.units} block={false} /></span>
        </div>
      )}
      {f.when_to_use && (
        <div className="mt-1 flex gap-2 items-start text-xs">
          <span className="font-mono text-[9px] uppercase tracking-widest text-[#3B82F6] mt-0.5 w-14 flex-shrink-0">Use When</span>
          <span className="flex-1 text-zinc-700">{renderRich(f.when_to_use, regex)}</span>
        </div>
      )}
    </div>
  );
}

export function FormulaSheetSection({ formulas, regex }) {
  if (!formulas?.length) return null;
  return (
    <Section label="Formula Sheet">
      <div className="grid sm:grid-cols-2 gap-3">
        {formulas.map((f, i) => (
          <FormulaCard key={i} f={f} regex={regex} />
        ))}
      </div>
    </Section>
  );
}
